import { Heart as IconHeart } from "iconsax-react";

const Heart = (props: any) => (
  <IconHeart variant="Bold" color="red" {...props} />
);

export default Heart;
